import Vue from 'vue'
import resourceModel from './resourceModel.js'

//加载字典项枚举js
import dictEnum from './enum/dictEnum.js'
//加载状态字典项
import statusEnum from './enum/statusEnum.js'
//加载角色字典项
import roleEnum from './enum/roleEnum.js'

//加载角色字典项
import menuBarList from './enum/menuBarList.js'

//获取动态的config文件
let config, serviceConfig;
if (sessionStorage.getItem("config") && sessionStorage.getItem("serviceConfig")) {
	config = JSON.parse(sessionStorage.getItem("config"))
	serviceConfig = JSON.parse(sessionStorage.getItem("serviceConfig"))
} else {
	alert("未能加载配置文件")
}


//记录尚未配置的服务包名称，用于提示
let errorList = []

//循环配置的服务包名称，读取每个服务的配置
config.ServiceList.forEach(function(item) {
	//从服务配置文件中查找当前服务包信息
	//serviceConfig存在该服务属性
	if (serviceConfig.hasOwnProperty(item)) {
		//服务包信息找到,进行赋值操作,具体约定查看serviceConfig.js说明
		let sList = serviceConfig[item]
		//替换掉service为s,示例，服务001请求地址为s001
		let keyStr = item.replace("service", "s")
		config.Url[keyStr] = config.isPublic ? config.Url["system"] : sList[0]

	} else {
		//服务包信息未找到，推入错误信息数组中
		errorList.push(item)
	}
})

export default {
	// return ExtractTextPlugin.extract({
	//   use: loaders,
	//   fallback: 'vue-style-loader',
	//   publicPath: '../../' //添加这一行代码后再重新打包就可以了
	// }),
	// 服务端地址
	Url: config.Url,
	SystemName: config.SystemName,
	resourceModel: resourceModel,
	//固定字典
	DictEnum: dictEnum,
	StatusEnum: statusEnum,
	//角色字典项
	RoleEnum: roleEnum,
	MenuBarList: menuBarList,
	MenuEnum: {
		//添加用户 
		useradd: "98cda9a0-c4eb-4c74-968e-e5c82c270cc2",
		//用户管理
		user: "C7CF51A8-BD0F-4567-9C25-8FA759941571",
		//学员
		stu: "49556BD4-C792-493D-8B51-FD355D6F7AAA",
		//单位管理
		employer: "67920248-510A-4272-B978-EDDB606B0016",
		//科室管理
		department: "59A15353-638D-4F81-9687-96144172D523",
		//药物管理
		bd002: "fce68d77-5234-4484-9321-3b173ae4b3aa",
		//异常菜单 
		error: "F8BE3B15-563E-A006-03F1-16E46D3C1A09",
		//字典管理
		dictitem: "F5C80749-ABD4-45AF-8F88-6BE8B04CF7E7",
		//已入组患者
		patinlist: "6c8e601a-2f7b-4868-8dd1-aacfa2d8a38b",
		//随访数据列表 
		followdatalist: "dbff3de6-2d07-4627-b33c-7c0ca9bc57b9",

	},
	// 日期格式化
	DateFormat(row, column) {
		var daterc = row[column.property]
		if (daterc != null) {
			var dateMat = new Date(daterc.replace('T', ' '))
			var year = dateMat.getFullYear()
			var month = dateMat.getMonth() + 1
			var day = dateMat.getDate()
			var hh = dateMat.getHours()
			var mm = dateMat.getMinutes()
			var ss = dateMat.getSeconds()
			var timeFormat = year + '-' + month + '-' + day + ' ' + hh + ':' + mm + ':' + ss
			return timeFormat
		}
	},
	// 日期字符串处理，保留年月日信息
	DateStringFormat(dateStr) {
		if (dateStr && dateStr.length > 10) {
			return dateStr.substring(0, 10)
		} else {
			return ""
		}
	},
	CheckUser(userID, obj) {
		if (userID == undefined || userID == '') {
			//跳转到注册页面
			obj.$parent.DisplayNav = false
			obj.$router.push('/center/register')
		} else {
			obj.$parent.DisplayNav = true
		}
	},
	// 变更操作
	Change(url, args, message, reflash) {
		let v = new Vue()
		v.$confirm(message, '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			v.$http.post(url, args)
				.then(res => {
					console.log(res.data)
					if (res.data.code === 0) {
						v.$dialog({
							message: '变更成功',
							type: 'success'
						})
						console.log('刷新页面')
						reflash()
						// v.$router.push(v.back)
					} else {
						v.$dialog({
							message: res.data.msg + '，' + res.data.error,
							type: 'error'
						})
					}
				})
				.catch(err => {
					console.log(err)
					v.$dialog({
						message: '变更失败',
						type: 'error'
					})
				})
		}).catch(() => {})
	},
	Guid() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random() * 16 | 0,
				v = c == 'x' ? r : (r & 0x3 | 0x8)
			return v.toString(16)
		})
	},
	// 删除操作
	Delete(url, name, reflash) {
		let v = new Vue()
		v.$dialog.confirm({
			// confirmButtonText: '确定',
			// cancelButtonText: '取消',
			// type: 'warning'
			// title: '标题',
			message: '删除 ' + name + ' 的信息, 是否继续?',
		}).then(() => {
			v.$http.delete(url)
				.then(res => {
					console.log(res.data)
					if (res.data.code === 0) {
						v.$dialog({
							message: '删除成功',
						})
						console.log('刷新页面')
						reflash()
						// v.$router.push(v.back)
					} else {
						v.$dialog({
							message: res.msg + ',' + res.error,
							type: 'error'
						})
					}
				})

		}).catch(() => {

		})
	},
	// 删除操作
	DeleteNet(url, args,name, reflash) {
		let v = new Vue()
		v.$dialog.confirm({
			// confirmButtonText: '确定',
			// cancelButtonText: '取消',
			// type: 'warning'
			// title: '标题',
			message: '删除 ' + name + ' 的信息, 是否继续?',
		}).then(() => {
			v.$http.post(url,args)
				.then(res => {
					console.log(res.data)
					if (res.data.code === 0) {
						v.$dialog({
							message: '删除成功',
						})
						console.log('刷新页面')
						reflash()
						// v.$router.push(v.back)
					} else {
						v.$dialog({
							message: res.msg + ',' + res.error,
							type: 'error'
						})
					}
				})
	
		}).catch(() => {
	
		})
	},
	// Http Get 请求
	HttpGet(url, FunSucess, FunFail, FunError, model) {
		let v = new Vue()
		let that = this;
		v.$http.get(url, {})
			.then(res => {
				//console.log(res.data)
				if (res.data.code === 0) {
					if (FunSucess != null) {
						FunSucess(res.data, model)
					} else {
						v.$message({
							message: '操作成功',
							type: 'success'
						})
					}
				} else {
					if (FunFail != null) {
						FunFail(res.data, model)
					} else {
						//修改,调用返回登录页方法
						that.backToLogin(res.data);
					}
				}
			})
			.catch(err => {
				console.log(err)
				if (FunError != null) {
					FunError()
				} else {
					v.$dialog({
						message: '操作失败',
						type: 'error'
					})
				}
			})
	},
	// Http Post 请求
	HttpPost(url, args, FunSucess, FunFail, FunError, model) {
		let v = new Vue()
		v.$http.post(url, args)
			.then(res => {
				// console.log(res.data)
				if (res.data.code === 0) {
					if (FunSucess != null) {
						FunSucess(res.data, model)
					} else {
						v.$dialog({
							message: '操作成功'
						})
					}
				} else {
					if (FunFail != null) {
						FunFail(res.data, model)
					} else {
						v.$dialog({
							message: res.data.error
						})
					}
				}
			})
			.catch(err => {
				console.log(err)
				if (FunError != null) {
					FunError()
				} else {
					v.$dialog({
						message: '操作失败' + err
					})
				}
			})
	},
	// Http Put 请求
	HttpPut(url, args, FunSucess, FunFail, FunError, model) {
		let v = new Vue()
		v.$http.put(url, args)
			.then(res => {
				if (res.data.code === 0) {
					if (FunSucess != null) {
						FunSucess(res.data, model)
					} else {
						v.$dialog({
							message: '操作成功',
						})
					}
				} else {
					if (FunFail != null) {
						FunFail(res.data, model)
					} else {
						v.$dialog({
							message: res.data.Msg
						})

					}
				}
			})
			.catch(err => {
				console.log(err)
				if (FunError != null) {
					FunError()
				} else {
					v.$dialog({
						message: '操作失败' + err
					})
				}
			})
	},
	//首字母大写
	toUpperCaseFirst(str) {
		return str = str.substring(0, 1).toUpperCase() + str.substring(1)
	},
	//首字母小写
	toLowerCaseFirst(str) {
		return str = str.substring(0, 1).toLowerCase() + str.substring(1)
	},
	//获得AccessToken，用于提交表单
	getAccessToken: function() {
		// let v = new Vue();
		// let that = this;
		// let urlGetAccessToken = that.Url.system + "/S000/auth/getaccesstoken"
		// v.$http.post(urlGetAccessToken, {})
		//   .then(res => {
		//     if (res.data.code == 0) {
		//       sessionStorage.setItem("AccessToken", res.data.data)
		//       //动态设置返回头，添加AccessToken
		//       v.$http.defaults.headers.common["AccessToken"] = res.data.data;
		//     } else {
		//       v.$dialog({
		//         message: '接口调用失败'
		//       })
		//       // v.$dialog({
		//       //   message: '接口调用失败'
		//       // })
		//     }
		//   })
		//   .catch(err => {
		//     console.log(err);
		//     v.$dialog({
		//       message: '接口调用失败'
		//     })
		//   })
	},
	// 页面跳转
	RouterPush(url) {
		let v = new Vue()
		v.$router.push(url)
	},
	//克隆对象
	clone(obj) {
		return JSON.parse(JSON.stringify(obj));
	},

	//对象同名属性拷贝
	CopyPro: function(fObj, TObj) {
		for (let key in fObj) {
			if (key in TObj) {
				TObj[key] = fObj[key]
			}
		}
	},
	// 属性拷贝，同属性覆盖，TObj没有的属性会新增
	CopyAllPro(fObj, TObj) {
		for (let key in fObj) {
			TObj[key] = fObj[key]
		}
	},
	//对象同名属性拷贝, 去掉_是否一样
	CopyKeySave: function(fObj, TObj) {
		for (let key in TObj) { //从需要赋值取带_
			if (key.indexOf('_') > 0) {
				let fkey = key.replaceAll('_', '').toLowerCase()
				if (fkey in fObj) {
					TObj[key] = fObj[fkey]
				}
			}
		}
	},
	CopyKeyInfo: function(fObj, TObj) {
		for (let key in TObj) { //从需要赋值取带_
			if (key.indexOf('_') > 0) {
				let fkey = key.replaceAll('_', '').toLowerCase()
				fObj[fkey] = TObj[key]
			}
		}
	},
	/**
	 * 过滤出数组中符合条件的第一条数据
	 * list 需要过滤的数组
	 * listPro  数组中过滤用的字段
	 * filterValue  进行过滤的值
	 * resultPro    过滤后需要的字段，可选，默认为name
	 */
	filterOne: function(list, listPro, filterValue, resultPro = "name") {
		let reValue = ""
		let filterList = list.filter(function(m) {
			return m[listPro] == filterValue
		})
		if (filterList.length > 0) {
			reValue = filterList[0][resultPro]
		}
		return reValue
	},
	//获取当前时间生成的随机数
	GetTimeNum: function() {
		var randomNum = ""; //订单号
		for (var i = 0; i < 5; i++) //5位随机数，用以加在时间戳后面。
		{
			randomNum += Math.floor(Math.random() * 10);
		}
		const now = new Date()
		const year = now.getFullYear();
		let month = now.getMonth() + 1;
		let day = now.getDate();
		let hour = now.getHours();
		let minutes = now.getMinutes();
		let seconds = now.getSeconds();
		String(month).length < 2 ? (month = "0" + month) : month;
		String(day).length < 2 ? (day = "0" + day) : day;
		String(hour).length < 2 ? (hour = "0" + hour) : hour;
		String(minutes).length < 2 ? (minutes = "0" + minutes) : minutes;
		String(seconds).length < 2 ? (seconds = "0" + seconds) : seconds;
		const yyyyMMddHHmmss = `${year}${month}${day}${hour}${minutes}${seconds}`;
		return yyyyMMddHHmmss + randomNum
	},
	//获得当前时间格式 yyyy-MM-dd hh:mm
	GetNowDateStr() {
		const now = new Date()
		const year = now.getFullYear();
		let month = now.getMonth() + 1;
		let day = now.getDate();
		let hour = now.getHours();
		let minutes = now.getMinutes();
		String(month).length < 2 ? (month = "0" + month) : month;
		String(day).length < 2 ? (day = "0" + day) : day;
		String(hour).length < 2 ? (hour = "0" + hour) : hour;
		String(minutes).length < 2 ? (minutes = "0" + minutes) : minutes;
		return `${year}-${month}-${day} ${hour}:${minutes}`;
	},
	// 日期字符串格式转化
	// 获得日期格式 yyyy-MM-dd hh:mm:ss
	dateToStrAll(dateStr) {
		if (!dateStr) {
			return
		}
		const now = new Date(dateStr)
		const year = now.getFullYear();
		let month = now.getMonth() + 1;
		let day = now.getDate();
		let hour = now.getHours();
		let minutes = now.getMinutes();
		let seconds = now.getSeconds();
		String(month).length < 2 ? (month = "0" + month) : month;
		String(day).length < 2 ? (day = "0" + day) : day;
		String(hour).length < 2 ? (hour = "0" + hour) : hour;
		String(minutes).length < 2 ? (minutes = "0" + minutes) : minutes;
		String(seconds).length < 2 ? (seconds = "0" + seconds) : seconds;
		return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
	},
	//给日期加上天数
	addDay(dayNumber, date) {	 
	        date = date ? new Date(date) : new Date();	 
	        var ms = dayNumber * (1000 * 60 * 60 * 24)	 
	        var newDate = new Date(date.getTime() + ms);	 
	        return newDate;
			},
	/**
	 * 根据路由名称，获得对应的组件模型
	 * pathName  路由的name属性
	 */
	GetComponentByPath: function(pathName) {
		//  let v = new Vue()
		console.log(pathName);
		//  var routes = v.$router;
		console.log(Vue)
		//  let filterRouteList = [];
		//  //过滤出对应的路由信息
		//  routes.forEach(function(item) {
		//    if (item.name == pathName) {
		//      filterRouteList.push(item);
		//    }
		//  })
		//  if (filterRouteList.length > 0) {
		//    return filterRouteList[0].component
		//  } else {
		//    return null
		//  }

	},
	// 动态执行脚本
	dynamicFun(script, model, key = "$$") {
		// 表达式为空，返回false
		if (!script) return false
		// 判断表达式是否包含return
		const func = script.indexOf('return') >= 0 ? '{' + script + '}' : 'return (' + script + ')'
		// 生成动态方法
		const Fn = new Function(key, func)
		// 执行方法，返回结果
		return Fn(model)
	},
	// 将字符串数组转化为标准的 id,name对象数组
	setStandardList(list) {
		let reList = list.map(item => {
			return {
				id: item,
				name: item
			}
		})
		return reList
	},
	// 获得年份数组
	// beforeYear 当前年多少年前
	// afterYear  当前年多少年后
	getYearList(beforeYear, afterYear = 0) {
		let now = new Date()
		// 获得当前年
		let nowYear = now.getFullYear();
		// 获得年限范围边界值
		let minYear = nowYear - beforeYear
		let maxYear = nowYear + afterYear
		// 年限范围数组
		let yearList = []
		for (let i = minYear; i <= maxYear; i++) {
			yearList.push(i)
		}
		return yearList
	},
	// 根据出生日期计算年龄的方法
	calculateAge(birthDate, currentData) {
		if (!birthDate) return ''
		
		// 解析出生日期
		var birthDateObj = new Date(birthDate)

		var today = new Date()
		// 获取当前日期
		if(currentData){
			today = new Date(currentData)	
		}		
		var currentYear = today.getFullYear()
		var currentMonth = today.getMonth() + 1
		var currentDay = today.getDate()
		
		// 获取出生年月日
		var birthYear = birthDateObj.getFullYear()
		var birthMonth = birthDateObj.getMonth() + 1
		var birthDay = birthDateObj.getDate()
		
		// 计算年龄
		var age = currentYear - birthYear - 1
		
		// 如果当前月份大于出生月份，或者当前月份等于出生月份但当前日期大于等于出生日期，则年龄加1
		if (currentMonth > birthMonth || (currentMonth === birthMonth && currentDay >= birthDay)) {
			age++
		}
		
		// 确保年龄不小于1
		if (age <= 0) {
			age = 1
		}
		
		return age
	}
}
